import { render, staticRenderFns } from "./PolizasFinanzasCard.vue?vue&type=template&id=ec82d28a&scoped=true&"
import script from "./PolizasFinanzasCard.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasCard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasFinanzasCard.vue?vue&type=style&index=0&id=ec82d28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82d28a",
  null
  
)

export default component.exports